import { createContext } from 'react';

const LocationsContext = createContext({
    /**
     * Although it is possible to remove the following I like to keep them here
     * because they help anyone importing UserDetailsContext to understand what properties/functions
     * this particular context has available
     */

    locations:
    {
        location: {
            // location:
            id: 0,
            name: '',
            devices:
            {
                device: {
                    // Device:
                    id: 0,
                    deviceType: '',
                    firmwareVersion: '',
                    lastKnownPublicIP: '',
                    lastKnowIP: '',
                    description: ''
                }
            },
            groups:
            {
                group: {}
            }
        },
    },
    activeLocationId: 0,
    activeGroupIds: { "0": { groupId: 0 } },

    /**
     * {Object} locations array of location objects, each with an array of device objects i.e. {[id], [name], [devices[]]}
     * @param {object} locationsContext the locations context to update
     */
    setLocations: locationsContext => { },
    setActiveLocationId: locationsContext => { },
    setActiveGroupId: locationsContext => { }
});

export default LocationsContext;


// WEBPACK FOOTER //
// ./src/context/locations.Context.js